import Header from "./components/Header";
import Hero from "./components/Hero";
import Entrance from "./components/Entrance";
import Trending from "./components/Trending";
import Guide from "./components/Guide";
import Cta from "./components/Cta";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

const jsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      name: "吃瓜路线",
      alternateName: "吃瓜路线平台入口",
      description:
        "吃瓜路线汇总微博、抖音、贴吧、B站等主流平台的热点入口，一步直达热搜与讨论现场。",
      inLanguage: "zh-CN",
    },
    {
      "@type": "WebPage",
      name: "吃瓜路线 · 全网热点平台入口直达指南",
      description:
        "汇总微博、抖音、贴吧、B站等主流平台热点入口，提供今日热议榜、围观路线指南与多平台直达导航。",
      inLanguage: "zh-CN",
    },
    {
      "@type": "FAQPage",
      inLanguage: "zh-CN",
      mainEntity: [
        {
          "@type": "Question",
          name: "吃瓜路线是什么？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "吃瓜路线是一个汇总各平台热点入口的内容导航站，把微博热搜、抖音热榜、贴吧热议等常去的讨论现场整理在同一页面，方便一键跳转围观。",
          },
        },
        {
          "@type": "Question",
          name: "入口会不会随时失效？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "我们收录的都是各平台公开的官方页面与常青入口，稳定性高。若个别页面发生调整，站内会及时更新替换。",
          },
        },
        {
          "@type": "Question",
          name: "围观需要注册登录吗？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "浏览各平台部分公开内容无需登录，但发表评论、参与讨论通常需要对应平台自己的账号。",
          },
        },
        {
          "@type": "Question",
          name: "如何快速找到正在热议的话题？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "优先进入各平台热搜榜、热榜或热议频道，再结合站内今日热议方向，按分类切换即可快速锁定当下最热闹的现场。",
          },
        },
        {
          "@type": "Question",
          name: "围观热点时需要注意什么？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "建议先在多个平台交叉核对再下结论；对未经证实的传闻保持谨慎，不轻信、不造谣、不传播，尊重当事人隐私，理性表达观点。",
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <div className="min-h-screen bg-background-50">
        <Header />
        <main>
          <Hero />
          <Entrance />
          <Trending />
          <Guide />
          <Cta />
          <Faq />
          <About />
        </main>
        <Footer />
        <BackToTop />
      </div>
    </>
  );
}